import { apiGet } from '~/utils/api'

export interface ActiveWeeklyDeal {
  id: string
  targetType: 'PRODUCT' | 'INVENTORY_ITEM'
  inventoryItemId: string | null
  headline: string
  subtitle: string | null
  headlineTranslations: Record<string, string> | null
  subtitleTranslations: Record<string, string> | null
  startsAt: string
  endsAt: string
  regularPrice: number
  campaignPrice: number
  currencyCode: string
  bannerImageUrl: string | null
  shopProductId: string
  productTitle: string
  productTitleTranslations: Record<string, string> | null
  productSlug: string | null
  productImages: string[]
  conditionGrade: string | null
  batteryHealth: number | null
  storage: string | null
  color: string | null
  availableStock: number
}

export function useWeeklyDealAPI() {
  return {
    fetchCurrentWeeklyDeal: () => apiGet<ActiveWeeklyDeal | null>('/api/app/v1/marketing/weekly-deal'),
  }
}
